import { windowDays, revenueByStoreDay, dayKeyOf, reportingNow } from '@/domain/reportingEngine';

/**
 * Network revenue for the owner dashboard (Prompt K, K3). Reads the reporting
 * engine's `revenueByStoreDay` so the ours-vs-artist / gross rules stay single-
 * sourced - this module never recomputes revenue its own way.
 */

export interface WeekRevenue {
  /** Day-key the week bucket ends on, inclusive (e.g. '2026-05-04'). */
  weekEndIso: string;
  /** Total network revenue across the seven days ending `weekEndIso`. */
  totalAud: number;
}

/**
 * Network revenue totalled per week for the last `weeks` weeks, oldest first.
 * Each bucket is the seven days ending on its `weekEndIso`, non-overlapping - so
 * the last entry is the current running week.
 */
export function networkRevenueByWeek(now: string = reportingNow(), weeks = 8): WeekRevenue[] {
  const today = dayKeyOf(now);
  const out: WeekRevenue[] = [];
  for (let k = weeks - 1; k >= 0; k -= 1) {
    // The oldest day of a (k*7 + 1)-day window ending today is today minus k*7.
    const weekEndIso = windowDays(today, k * 7 + 1)[0]!;
    const days = windowDays(weekEndIso, 7);
    const totalAud = revenueByStoreDay(days).reduce((sum, r) => sum + r.totalAud, 0);
    out.push({ weekEndIso, totalAud });
  }
  return out;
}
